import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import AdBanner from './AdBanner';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, title }) => {
  const [showAds, setShowAds] = useState<boolean | null>(null);

  useEffect(() => {
    // Check for ad consent and show ads after a delay
    const adConsent = localStorage.getItem('advertisingConsent');
    if (adConsent === 'true') {
      // Use requestAnimationFrame to ensure we're in the browser
      requestAnimationFrame(() => {
        setShowAds(true);
      });
    } else {
      setShowAds(false);
    }
  }, []);

  // Don't render ads until we know the consent status
  const shouldShowAds = showAds === true;

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      {shouldShowAds && (
        <div className="w-full max-w-7xl mx-auto px-4 py-2">
          <AdBanner format="horizontal" />
        </div>
      )}
      <main className="flex-grow">{children}</main>
      {shouldShowAds && (
        <div className="w-full max-w-7xl mx-auto px-4 py-2">
          <AdBanner format="horizontal" />
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Layout; 